import apiClient from '../../apiClient';
import '../../App.css'
import { useEffect, useState } from 'react';
import { DataGrid } from '@mui/x-data-grid'
import { SelectGenericFromTable } from '../universal/Axios';
import { observer } from "mobx-react"
import { GetPerformancePercentile } from '../universal/InternalCalculator';
import Button from '@mui/material/Button'
import ArrowForward from '@mui/icons-material/ArrowForward';
import DeleteIcon from '@mui/icons-material/Delete';
import Tooltip from '@mui/material/Tooltip';
import { HandleAuthError, GenericStackTraceValidator } from '../universal/Alert';
import { getStore } from '../../Store'
import SyncIcon from '@mui/icons-material/Sync';
import Box from '@mui/material/Box';
import { CustomToolbar } from '../universal/GridHelper';
const store = getStore();


const NetworkBatchTable = observer(() => {
    //const networkBatchData = store.networkBatches
    const [networkBatchData, setNetworkBatchData] = useState([]);

    const triggerNetworkBatch = (network_batch_id) => {
        store.updateStatusMessage("Triggering network batch...")
        apiClient.post(
            "https://us-central1-airy-semiotics-297902.cloudfunctions.net/interactive-density-network",
            {
                "function_to_execute": "Handle_Batch_Network_Run_Queues_By_Batch_ID",
                "network_batch_id": network_batch_id,
            }
        ).then(({ data }) => {
            store.updateSuccessMessage("Successfully triggered network batch!")
        }).catch(function (error) {
            if (error?.response?.status === 401) {
                HandleAuthError()
            } else {
                console.log(error?.response?.data)
                store.updateErrorMessage("Error while triggering network batch")
            }
        })
    }
    const deleteNetworkBatch = (network_batch_id) => {
        store.updateStatusMessage("Deleting network batch...")
        apiClient.post(
            "https://us-central1-airy-semiotics-297902.cloudfunctions.net/interactive-density-network",
            {
                "function_to_execute": "Delete_Batch",
                "network_batch_id": network_batch_id,
            }
        ).then(({ data }) => {
            store.updateSuccessMessage("Successfully deleted network batch!")
            window.location.reload();
        }).catch(function (error) {
            if (error?.response?.status === 401) {
                HandleAuthError()
            } else {
                console.log(error?.response?.data)
                store.updateErrorMessage("Error while deleting network batch")
            }
        })
    }

    const updateNetworkBatchStatus = (network_batch_id) => {
        store.updateStatusMessage("Syncing network batch...")
        apiClient.post(
            "https://us-central1-airy-semiotics-297902.cloudfunctions.net/interactive-density-network",
            {
                "function_to_execute": "Update_Batch_Status",
                "network_batch_id": network_batch_id,
            }
        ).then(({ data }) => {
            store.updateSuccessMessage("Successfully synced network batch!")
            window.location.reload();
        }).catch(function (error) {
            store.updateErrorMessage("Error while syncing network batch")
        })
    }

    useEffect(() => {
        console.log("selecting network batches")
        SelectGenericFromTable("SELECT nb.*, nrq.si_sdr FROM network_batch nb LEFT JOIN network_run_queue nrq ON nrq.id = (SELECT MIN(nrq2.id) nrq_id FROM network_run_queue nrq2 WHERE nrq2.network_batch_id = nb.id and nrq2.si_sdr is not null) order by created_date desc", setNetworkBatchData)
        console.log(networkBatchData)
    }, []);


    if (networkBatchData === undefined) {
        return (<p>loading...</p>)
    }

    const networkBatchColumns = [
        {
            field: 'actions',
            headerName: 'Actions',
            width: 125,
            renderCell: (params) => (
                <>
                    <Box sx={{ width: '200px', justifyContent: 'space-around' }}>
                        <Tooltip title="Sync Info">
                            <Button
                                href="#"
                                onClick={() => updateNetworkBatchStatus(params.row.id)}
                                style={{ minWidth: '35px', maxWidth: '35px' }}
                            >
                                <SyncIcon />
                            </Button>
                        </Tooltip>
                        {params.row.completion_percentage !== 100 &&
                            <Tooltip title="Trigger">
                                <Button
                                href="#"
                                onClick={() => triggerNetworkBatch(params.row.id)}
                                    style={{ minWidth: '35px', maxWidth: '35px' }}
                            >
                                    <ArrowForward />
                                </Button>
                            </Tooltip>
                        }
                        {params.row.si_sdr === null &&
                            <Tooltip title="Delete">
                                <Button
                                href="#"
                                onClick={() => deleteNetworkBatch(params.row.id)}
                                    style={{ minWidth: '35px', maxWidth: '35px' }}
                            >
                                    <DeleteIcon />
                                </Button>
                            </Tooltip>
                    }
                    </Box>
                </>
            ),
        },
        {
            field: 'id',
            headerName: 'ID',
            width: 420,
            renderCell: (params) => (
                <>
                    <a
                        href={'edit-network-batch?id=' + params.row.id}
                        target="_blank"
                        //onClick={() => editNetworkRun(params)}
                    >
                        {params.row.id}
                    </a>
                </>
            ),
        },
        {
            field: 'status',
            headerName: 'Status',
            width: 180,
        },
        {
            field: 'completion_percentage',
            headerName: 'Percent Complete',
            width: 140,
            renderCell: (params) => (
                params.value != null ?
                    <span style={{ opacity: .2 + (parseFloat(params.row.completion_percentage) / 100) * .8}}
                    >
                        {params.value.toString()}
                    </span> : <span></span>
            ),
        },
        {
            field: 'average_si_sdr',
            headerName: 'Average SI-SDR',
            width: 140,
            renderCell: (params) => (
                params.value != null ?
                    <span style={{ color: 'rgb(' + ((1 - parseFloat(params.row.relative_average_si_sdr)) * 255) + ',' + (parseFloat(params.row.relative_average_si_sdr) * 255) + ',0)' }}
                    >
                        {params.value.toString()}
                    </span> : <span></span>
            ),
        },
        {
            field: 'median_si_sdr',
            headerName: 'Median SI-SDR',
            width: 140,
            renderCell: (params) => (
                params.value != null ?
                    <span style={{ color: 'rgb(' + ((1 - parseFloat(params.row.relative_median_si_sdr)) * 255) + ',' + (parseFloat(params.row.relative_median_si_sdr) * 255) + ',0)' }}
                    >
                        {params.value.toString()}
                    </span> : <span></span>
            ),
        },
        {
            field: 'average_speech_signal_consolidation_score',
            headerName: 'Avg Speech Signal Consolidation Score',
            width: 140,
            renderCell: (params) => (
                params.value != null ?
                    <span style={{ color: 'rgb(' + ((1 - parseFloat(params.row.relative_average_speech_signal_consolidation_score)) * 255) + ',' + (parseFloat(params.row.relative_average_speech_signal_consolidation_score) * 255) + ',0)' }}
                    >
                        {params.value.toString()}
                    </span> : <span></span>
            ),
        },
        {
            field: 'average_speech_transform_activation_score',
            headerName: 'Avg Speech Transform Activation Score',
            width: 140,
            renderCell: (params) => (
                params.value != null ?
                    <span style={{ color: 'rgb(' + ((1 - parseFloat(params.row.relative_average_speech_transform_activation_score)) * 255) + ',' + (parseFloat(params.row.relative_average_speech_transform_activation_score) * 255) + ',0)' }}
                    >
                        {params.value.toString()}
                    </span> : <span></span>
            ),
        },
        {
            field: 'average_speech_channel_assignment_score',
            headerName: 'Avg Speech Channel Assignment Score',
            width: 140,
            renderCell: (params) => (
                params.value != null ?
                    <span style={{ color: 'rgb(' + ((1 - parseFloat(params.row.relative_average_speech_channel_assignment_score)) * 255) + ',' + (parseFloat(params.row.relative_average_speech_channel_assignment_score) * 255) + ',0)' }}
                    >
                        {params.value.toString()}
                    </span> : <span></span>
            ),
        },
        {
            field: 'description',
            headerName: 'Description',
            width: 300,
        },
        {
            field: 'created_date',
            headerName: 'Created Date',
            width: 280,
        },
        {
            field: 'run_date',
            headerName: 'Run Date',
            width: 280,
        },
        {
            field: 'si_sdr',
            headerName: 'SISDR',
            width: 280,
            hide: true
        }
    ];

    let networkBatchDataRows = networkBatchData?.filter(data => data != null).map((networkBatch) =>
    ({   
        id: networkBatch.id,
        description: networkBatch.description,
        completion_percentage: networkBatch.completion_percentage,
        average_si_sdr: networkBatch.average_si_sdr,
        median_si_sdr: networkBatch.median_si_sdr,
        average_speech_signal_consolidation_score: networkBatch.average_speech_signal_consolidation_score,
        average_speech_transform_activation_score: networkBatch.average_speech_transform_activation_score,
        average_speech_channel_assignment_score: networkBatch.average_speech_channel_assignment_score,
        status: networkBatch.status,
        created_date: networkBatch.created_date,
        run_date: networkBatch.run_date,
        si_sdr: networkBatch.si_sdr,
    }))
    networkBatchDataRows = GetPerformancePercentile(networkBatchDataRows, 'average_si_sdr', 'relative_average_si_sdr', 0);
    networkBatchDataRows = GetPerformancePercentile(networkBatchDataRows, 'median_si_sdr', 'relative_median_si_sdr', 0);
    networkBatchDataRows = GetPerformancePercentile(networkBatchDataRows, 'average_speech_signal_consolidation_score', 'relative_average_speech_signal_consolidation_score', 0);
    networkBatchDataRows = GetPerformancePercentile(networkBatchDataRows, 'average_speech_transform_activation_score', 'relative_average_speech_transform_activation_score', 0);
    networkBatchDataRows = GetPerformancePercentile(networkBatchDataRows, 'average_speech_channel_assignment_score', 'relative_average_speech_channel_assignment_score', 0);

    return (
        <DataGrid
            disableSelectionOnClick
            rows={networkBatchDataRows}
            columns={networkBatchColumns}
            pagination={true}
            initialState={{
              sorting: {
                    sortModel: [{ field: 'created_date', sort: 'desc' }, { field: 'id', sort: 'desc'}],
              },
            }}
            components={{
                Toolbar: () => CustomToolbar("Network_Batches")
            }}
      />
    )
});

export { NetworkBatchTable };
